// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".barcode-scanner__input[data-v-36f9b8f6]{margin:0;padding:0;height:0;overflow:hidden;display:block}", ""]);
// Exports
module.exports = exports;
